import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { PaymentAccount } from '../../models/payment-account';

@Injectable({
  providedIn: 'root'
})
export class PaymentAccountEventService implements OnDestroy {
  private paymentAccountUpdatedEvent: Subject<PaymentAccount> = new Subject<PaymentAccount>();
  private paymentAccountDeletedEvent: Subject<PaymentAccount> = new Subject<PaymentAccount>();
  private refreshEvent: Subject<void> = new Subject<void>();

  constructor() {}

  ngOnDestroy() {
    this.paymentAccountUpdatedEvent.complete();
    this.paymentAccountDeletedEvent.complete();
    this.refreshEvent.complete();
  }

  getPaymentAccountUpdatedEvent(): Observable<PaymentAccount> {
    return this.paymentAccountUpdatedEvent.asObservable();
  }

  sendPaymentAccountUpdatedEvent(paymentAccount: PaymentAccount) {
    this.paymentAccountUpdatedEvent.next(paymentAccount);
  }

  getPaymentAccountDeletedEvent(): Observable<PaymentAccount> {
    return this.paymentAccountDeletedEvent.asObservable();
  }

  sendPaymentAccountDeletedEvent(paymentAccount: PaymentAccount) {
    this.paymentAccountDeletedEvent.next(paymentAccount);
  }

  getRefreshEvent(): Observable<any> {
    return this.refreshEvent.asObservable();
  }

  sendRefreshEvent() {
    this.refreshEvent.next();
  }
}
